document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.bn-positions').forEach((block) => {
		const select = block.querySelector('.bn-positions__select');
		const submit = block.querySelector('.bn-positions__submit');
		const groups = block.querySelectorAll('.bn-positions__group');

		if (!select || !groups.length) {
			return;
		}

		const apply = () => {
			groups.forEach((group) => {
				group.classList.toggle('is-active', group.dataset.index === select.value);
			});
		};

		if (submit) {
			submit.addEventListener('click', apply);
		}

		select.addEventListener('keydown', (event) => {
			if (event.key === 'Enter') {
				event.preventDefault();
				apply();
			}
		});
	});
});
